module.exports = __webpack_public_path__ + "static/media/rich-video.f33eaac3.jpeg";